import React from 'react';

const Process = () => {
    return (
        <section className="section section--alt" id="process">
            <div className="container">
                <h2 className="section__title">How It Works</h2>
                <div className="process">
                    <div className="process-step">
                        <div className="process-step__number">1</div>
                        <h3 className="process-step__title">Request a Quote</h3>
                        <p>
                            Fill out the online form or call / text{' '}
                            <a href="tel:+15197318214">+1 519-731-8214</a>.
                        </p>
                    </div>
                    <div className="process-step">
                        <div className="process-step__number">2</div>
                        <h3 className="process-step__title">We Follow Up</h3>
                        <p>
                            You’ll receive a customized quote and recommended cleaning plan for your home,
                            office, or rental.
                        </p>
                    </div>
                    <div className="process-step">
                        <div className="process-step__number">3</div>
                        <h3 className="process-step__title">We Clean</h3>
                        <p>
                            Our team arrives on time with eco-friendly supplies and leaves your space fresh,
                            tidy, and ready to enjoy.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Process;
